import script from "./Select.vue?vue&type=script&lang=ts&setup=true"
export * from "./Select.vue?vue&type=script&lang=ts&setup=true"

import "./Select.vue?vue&type=style&index=0&id=72bbaf0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72bbaf0c"]])

export default __exports__